import FormatacaoUtils from "./FormatacaoUtils";
import Mensagens from "./MensagemUtils";
import StringUtils from "./StringUtils";
import { isSuperAdmin } from "./PermissaoUtils";

export const TipoValidacao = {
  LOGIN: "LOGIN",
  USUARIO_CRIAR: "USUARIO_CRIAR",
  USUARIO_EDITAR: "USUARIO_EDITAR",
  EMPRESA_CRIAR: "EMPRESA_CRIAR",
  CHAVES_CRIAR: "CHAVES_CRIAR",
  CLIENTE_CRIAR: "CLIENTE_CRIAR",
  LICENCA_CRIAR: "LICENCA_CRIAR",
};

export const ValidacaoUtils = {
  validateForm: (formData, type) => {
    let errors = {};

    switch (type) {
      case TipoValidacao.LOGIN:
        errors = validaLogin(formData?.login, formData?.senha);
        break;
      case TipoValidacao.USUARIO_CRIAR:
        errors = validarUsuario(formData, false);
        break;
      case TipoValidacao.USUARIO_EDITAR:
        errors = validarUsuario(formData, true);
        break;
      case TipoValidacao.EMPRESA_CRIAR:
        errors = validarEmpresa(formData);
        break;
      case TipoValidacao.CLIENTE_CRIAR:
        errors = validarCliente(formData);
        break;
      case TipoValidacao.LICENCA_CRIAR:
        errors = validarLicenca(formData);
        break;
        case TipoValidacao.CHAVES_CRIAR:
          errors = validarChaves(formData);
          break;
          
      default:
        console.error(`Tipo de validação desconhecido: ${type}`);
        return {
          success: false,
          errors: { general: "Tipo de validação desconhecido" },
        };
    }

    return { success: Object.keys(errors).length === 0, errors };
  },
};

/**
 * Valida os dados de usuário para criação ou edição
 */
const validarUsuario = (formData, editando) => {
  const { 
    nome = '', 
    grupoPermissao = '', 
    login = '', 
    senha = '', 
    confirmarSenha = '', 
    cpf = '', 
    empresa = '', 
    email = '' 
  } = formData || {};

  const errors = {};

  if (StringUtils.isEmptyOrNull(nome)) {
    errors.nome = Mensagens.USUARIO.ERRO.NOME_OBRIGATORIO;
  } else if (nome.length < 3) {
    errors.nome = Mensagens.USUARIO.ERRO.NOME_MINIMO;
  }

  if (StringUtils.isEmptyOrNull(login)) {
    errors.login = Mensagens.USUARIO.ERRO.LOGIN_OBRIGATORIO;
  } else if (login.length < 3) {
    errors.login = Mensagens.USUARIO.ERRO.LOGIN_MINIMO;
  }

  if (StringUtils.isEmptyOrNull(grupoPermissao)) {
    errors.grupoPermissao = Mensagens.USUARIO.ERRO.GRUPO_PERMISSAO_OBRIGATORIO;
  }
  
  if (isSuperAdmin && typeof isSuperAdmin === 'function') {
    if (isSuperAdmin()) {
      if (StringUtils.isEmptyOrNull(empresa)) {
        errors.empresa = Mensagens.USUARIO.ERRO.EMPRESA_OBRIGATORIA;
      }
    }
  } else {
    // fallback: mantém validação antiga se não encontrar função
    if (StringUtils.isEmptyOrNull(empresa)) {
      errors.empresa = Mensagens.USUARIO.ERRO.EMPRESA_OBRIGATORIA;
    }
  }

  if (!editando) {
    if (StringUtils.isEmptyOrNull(senha)) {
      errors.senha = Mensagens.USUARIO.ERRO.SENHA_OBRIGATORIA;
    } else if (senha.length < 4) {
      errors.senha = Mensagens.USUARIO.ERRO.SENHA_MINIMA;
    }
    
    if (StringUtils.isEmptyOrNull(confirmarSenha)) {
      errors.confirmarSenha = Mensagens.USUARIO.ERRO.CONFIRMAR_SENHA_OBRIGATORIA;
    } else if (confirmarSenha !== senha) {
      errors.confirmarSenha = Mensagens.USUARIO.ERRO.SENHAS_NAO_COINCIDEM;
    }
  } else {
    const senhaPreenchida = !StringUtils.isEmptyOrNull(senha) && senha !== Mensagens.USUARIO.SENHA_PLACEHOLDER_EDICAO;
    const confirmacaoPreenchida = !StringUtils.isEmptyOrNull(confirmarSenha) && confirmarSenha !== Mensagens.USUARIO.CONFIRMAR_SENHA_PLACEHOLDER_EDICAO;
    
    if (senhaPreenchida) {
      if (senha.length < 4) {
        errors.senha = Mensagens.USUARIO.ERRO.SENHA_MINIMA;
      }
      
      if (!confirmacaoPreenchida) {
        errors.confirmarSenha = Mensagens.USUARIO.ERRO.CONFIRMAR_SENHA_OBRIGATORIA;
      }
    }
    
    if (confirmacaoPreenchida) {
      if (!senhaPreenchida) {
        errors.senha = Mensagens.USUARIO.ERRO.SENHA_OBRIGATORIA;
      }
    }
    
    if (senhaPreenchida && confirmacaoPreenchida && senha !== confirmarSenha) {
      errors.confirmarSenha = Mensagens.USUARIO.ERRO.SENHAS_NAO_COINCIDEM;
    }
  }
  
  if (StringUtils.isEmptyOrNull(cpf)) {
    errors.cpf = Mensagens.USUARIO.ERRO.CPF_OBRIGATORIO;
  } else if (!validarCPF(cpf)) {
    errors.cpf = Mensagens.USUARIO.ERRO.CPF_INVALIDO;
  }
  
  if (StringUtils.isEmptyOrNull(email)) {
    errors.email = Mensagens.USUARIO.ERRO.EMAIL_OBRIGATORIO;
  } else if (!validarEmail(email)) {
    errors.email = Mensagens.USUARIO.ERRO.EMAIL_INVALIDO;
  }

  return errors;
};

/**
 * Valida os dados de uma empresa
 */
const validarEmpresa = (formData) => {
  const { 
    razaoSocial = '',
    cnpj = ''
  } = formData || {};

  const errors = {};

  if (StringUtils.isEmptyOrNull(razaoSocial)) {
    errors.razaoSocial = Mensagens.EMPRESA.ERRO.RAZAO_SOCIAL_OBRIGATORIA;
  }
  
  if (StringUtils.isEmptyOrNull(cnpj)) {
    errors.cnpj = Mensagens.EMPRESA.ERRO.DOCUMENTO_OBRIGATORIO;
  } else {
    // Utiliza a função validarDocumento que já suporta tanto CPF quanto CNPJ
    if (!validarDocumento(cnpj)) {
      errors.cnpj = Mensagens.EMPRESA.ERRO.DOCUMENTO_INVALIDO;
    }
  }

  return errors;
};


/**
 * Valida os dados de chaves
 */
const validarChaves = (formData) => {
  const { 
    idChaves = 0,
    descricao = '',
    idCliente = '',
    situacaoCadastro = true,
    unidade = '',
    limiteDiario = '',
    limiteSemanal = '',
    limiteMensal = '',
  } = formData || {};

  const errors = {};

  if (StringUtils.isEmptyOrNull(descricao)) {
    errors.descricao = Mensagens.DESENVOLVIMENTO.ERRO.DESCRICAO_OBRIGATORIA;
  }

  if (StringUtils.isEmptyOrNull(idCliente)) {
    errors.idCliente = Mensagens.DESENVOLVIMENTO.ERRO.CLIENTE_OBRIGATORIO;
  }

  if (StringUtils.isEmptyOrNull(unidade)) {
    errors.unidade = Mensagens.DESENVOLVIMENTO.ERRO.UNIDADE_OBRIGATORIA;
  }

  if (StringUtils.isEmptyOrNull(limiteDiario)) {
    errors.limiteDiario = Mensagens.DESENVOLVIMENTO.ERRO.LIM_DIARIO_OBRIGATORIO;
  } else if (isNaN(Number(limiteDiario)) || Number(limiteDiario) <= 0) {
    errors.limiteDiario = Mensagens.DESENVOLVIMENTO.ERRO.LIM_DIARIO_INVALIDO;
  } else if (Number(limiteDiario) > 9999999) {
    errors.limiteDiario = Mensagens.DESENVOLVIMENTO.ERRO.LIM_DIARIO_INVALIDO_MAX;
  }

  if (StringUtils.isEmptyOrNull(limiteSemanal)) {
    errors.limiteSemanal = Mensagens.DESENVOLVIMENTO.ERRO.LIM_SEMANAL_OBRIGATORIO;
  } else if (isNaN(Number(limiteSemanal)) || Number(limiteSemanal) <= 0) {
    errors.limiteSemanal = Mensagens.DESENVOLVIMENTO.ERRO.LIM_SEMANAL_INVALIDO;
  } else if (Number(limiteSemanal) > 9999999) {
    errors.limiteSemanal = Mensagens.DESENVOLVIMENTO.ERRO.LIM_SEMANAL_INVALIDO_MAX;
  }

  if (StringUtils.isEmptyOrNull(limiteMensal)) {
    errors.limiteMensal = Mensagens.DESENVOLVIMENTO.ERRO.LIM_MENSAL_OBRIGATORIO;
  } else if (isNaN(Number(limiteMensal)) || Number(limiteMensal) <= 0) {
    errors.limiteMensal = Mensagens.DESENVOLVIMENTO.ERRO.LIM_MENSAL_INVALIDO;
  } else if (Number(limiteMensal) > 9999999) {
    errors.limiteMensal = Mensagens.DESENVOLVIMENTO.ERRO.LIM_MENSAL_INVALIDO_MAX;
  }
  
  return errors;
};

/**
 * Valida os dados de um cliente
 */
const validarCliente = (formData) => {
  const {
    razaoSocial = '',
    documento = '',
    empresa = ''
  } = formData || {};

  const errors = {};

  if (StringUtils.isEmptyOrNull(razaoSocial)) {
    errors.razaoSocial = Mensagens.CLIENTE.ERRO.RAZAO_SOCIAL_OBRIGATORIA;
  } else if (razaoSocial.length < 3) {
    errors.razaoSocial = Mensagens.CLIENTE.ERRO.RAZAO_SOCIAL_MINIMO;
  }

  // Validação de empresa só para admin
  if (isSuperAdmin && typeof isSuperAdmin === 'function') {
    if (isSuperAdmin()) {
      if (StringUtils.isEmptyOrNull(empresa)) {
        errors.empresa = Mensagens.USUARIO.ERRO.EMPRESA_OBRIGATORIA;
      }
    }
  } else {
    if (StringUtils.isEmptyOrNull(empresa)) {
      errors.empresa = Mensagens.USUARIO.ERRO.EMPRESA_OBRIGATORIA;
    }
  }

  if (StringUtils.isEmptyOrNull(documento)) {
    errors.cnpj = Mensagens.CLIENTE.ERRO.DOCUMENTO_OBRIGATORIO;
  } else {
    const documentoLimpo = FormatacaoUtils.limparDocumento(documento);
    if (documentoLimpo.length <= 11) {
      // Valida como CPF
      if (!validarCPF(documentoLimpo)) {
        errors.cnpj = Mensagens.CLIENTE.ERRO.DOCUMENTO_INVALIDO;
      }
    } else {
      // Valida como CNPJ
      if (!validarCNPJ(documentoLimpo)) {
        errors.cnpj = Mensagens.CLIENTE.ERRO.DOCUMENTO_INVALIDO;
      }
    }
  }

  return errors;
};

/**
 * Valida informações de login
 */
const validaLogin = (login = '', senha = '') => {
  const errors = {};

  if (StringUtils.isEmptyOrNull(login)) {
    errors.login = Mensagens.USUARIO.ERRO.LOGIN_OBRIGATORIO;
  } else if (login.length < 3) {
    errors.login = Mensagens.USUARIO.ERRO.LOGIN_MINIMO;
  }

  if (StringUtils.isEmptyOrNull(senha)) {
    errors.senha = Mensagens.USUARIO.ERRO.SENHA_OBRIGATORIA;
  } else if (senha.length < 4) {
    errors.senha = Mensagens.USUARIO.ERRO.SENHA_MINIMA;
  }

  return errors;
};


/**
 * Valida se um endereço de e-mail está em formato válido
 */
const validarEmail = (email) => {
  const re =
    /^[^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*@(([a-zA-Z\d-]+\.)+[a-zA-Z]{2,}|\[\d{1,3}(?:\.\d{1,3}){3}\])$/i;
  return re.test(String(email).toLowerCase());
};

/**
 * Valida se um documento está em formato válido (CPF ou CNPJ)
 */
const validarDocumento = (documento) => {
  if (!documento) return false;
  
  documento = FormatacaoUtils.limparDocumento(documento);
  
  // Verifica se é CPF ou CNPJ baseado no tamanho
  if (documento.length <= 11) {
    return validarCPF(documento);
  } else {
    return validarCNPJ(documento);
  }
};

/**
 * Valida se um CPF está em formato válido
 */
const validarCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]/g, '');
  
  if (cpf.length !== 11) {
    return false;
  }
  
  if (/^(\d)\1{10}$/.test(cpf)) {
    return false;
  }
  
  let soma = 0;
  let resto;
  
  for (let i = 1; i <= 9; i++) {
    soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i);
  }
  
  resto = (soma * 10) % 11;
  if ((resto === 10) || (resto === 11)) {
    resto = 0;
  }
  
  if (resto !== parseInt(cpf.substring(9, 10))) {
    return false;
  }
  
  soma = 0;
  for (let i = 1; i <= 10; i++) {
    soma = soma + parseInt(cpf.substring(i-1, i)) * (12 - i);
  }
  
  resto = (soma * 10) % 11;
  if ((resto === 10) || (resto === 11)) {
    resto = 0;
  }
  
  return resto === parseInt(cpf.substring(10, 11));
};

/**
 * Verifica se um CNPJ está em formato válido
 */
const validarCNPJ = (cnpj) => {
  cnpj = FormatacaoUtils.limparDocumento(cnpj);
  
  if (cnpj.length !== 14) {
    return false;
  }
  
  if (/^(\d)\1{13}$/.test(cnpj)) {
    return false;
  }
  
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  const digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado !== parseInt(digitos.charAt(0), 10)) {
    return false;
  }
  
  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  return resultado === parseInt(digitos.charAt(1), 10);
};

// Validação de Licença (Cadastro de Sistema)
const validarLicenca = (formData) => {
  const { plano = '', numeroPedido = '', unidadeNegocio = '' } = formData || {};
  const errors = {};
  if (StringUtils.isEmptyOrNull(plano)) errors.plano = 'Plano é obrigatório.';
  if (StringUtils.isEmptyOrNull(numeroPedido)) errors.numeroPedido = 'Número do pedido é obrigatório.';
  if (StringUtils.isEmptyOrNull(unidadeNegocio)) errors.unidadeNegocio = 'Unidade é obrigatória.';
  if (StringUtils.isEmptyOrNull(formData.expiracao)) errors.expiracao = 'Data de expiração é obrigatória.';
  else {
    let expiracao = formData.expiracao;
    // Se vier só números, formata para dd/mm/aaaa
    if (/^\d{8}$/.test(expiracao)) {
      expiracao = expiracao.replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3');
    }
    // Validação para dd/mm/aaaa (dia 01-31, mês 01-12)
    const regex = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/;
    const match = expiracao.match(regex);
    if (!match) {
      errors.expiracao = 'Data de expiração inválida.';
    } else {
      const dia = parseInt(match[1], 10);
      const mes = parseInt(match[2], 10);
      const ano = parseInt(match[3], 10);
      // Checagem de validade do calendário
      const data = new Date(ano, mes - 1, dia);
      if (
        data.getFullYear() !== ano ||
        data.getMonth() !== mes - 1 ||
        data.getDate() !== dia
      ) {
        errors.expiracao = 'Data de expiração inválida.';
      } 
    }
  }
  // Validação de data de cancelamento (se preenchida)
  if (!StringUtils.isEmptyOrNull(formData.cancelamento)) {
    let cancelamento = formData.cancelamento;
    if (/^\d{8}$/.test(cancelamento)) {
      cancelamento = cancelamento.replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3');
    }
    const regex = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/;
    const match = cancelamento.match(regex);
    if (!match) {
      errors.cancelamento = 'Data de cancelamento inválida.';
    } else {
      const dia = parseInt(match[1], 10);
      const mes = parseInt(match[2], 10);
      const ano = parseInt(match[3], 10);
      const data = new Date(ano, mes - 1, dia);
      if (
        data.getFullYear() !== ano ||
        data.getMonth() !== mes - 1 ||
        data.getDate() !== dia
      ) {
        errors.cancelamento = 'Data de cancelamento inválida.';
      }
    }
  }

  // Validação dos limites obrigatórios do sistema selecionado
  const sistema = formData.sistema;
  const limites = formData.limites || {};
  
  if (sistema) {
    console.log('Validando limites para sistema:', sistema);
    console.log('Limites recebidos:', JSON.stringify(limites));
    
    const limitesErrors = validarLimites(sistema, limites);
    
    // Log dos erros encontrados na validação de limites
    if (Object.keys(limitesErrors).length > 0) {
      console.log('Erros de validação de limites:', limitesErrors);
    }
    
    // Mescla os erros de limites ao objeto principal, usando prefixo 'limites.'
    Object.entries(limitesErrors).forEach(([key, value]) => {
      errors[`limites.${key}`] = value;
    });
  }

  return errors;
};

// Corrigir ordem dos parâmetros para evitar erro de default parameter
const validarLimites = (sistema, limites = {}) => {
  const errors = {};
  
  // Função auxiliar para verificar se um valor é vazio ou não
  const isEmptyValue = (value) => {
    return value === undefined || value === null || value === '';
  };
  
  switch (sistema) {
    case 'Ponto':
      if (isEmptyValue(limites.mobile)) errors.mobile = 'Limite obrigatório.';
      if (isEmptyValue(limites.equipamentos)) errors.equipamentos = 'Limite obrigatório.';
      if (isEmptyValue(limites.funcionarios)) errors.funcionarios = 'Limite obrigatório.';
      if (isEmptyValue(limites.usuarios)) errors.usuarios = 'Limite obrigatório.';
      break;
    case 'Chamado':
      if (isEmptyValue(limites.funcionarios)) errors.funcionarios = 'Limite obrigatório.';
      break;
    case 'Acesso':
      if (isEmptyValue(limites.equipamentos)) errors.equipamentos = 'Limite obrigatório.';
      if (isEmptyValue(limites.usuarios)) errors.usuarios = 'Limite obrigatório.';
      if (isEmptyValue(limites.pessoas)) errors.pessoas = 'Limite obrigatório.';
      break;
    default:
      break;
  }
  return errors;
};

ValidacaoUtils.validarLimites = (limites, sistema) => validarLimites(sistema, limites);

export { validaLogin, validarCNPJ, validarCPF, validarDocumento, validarEmail, validarLimites };
